module.exports = __webpack_public_path__ + "4369f512.svg";